import styles from '../../../pages/LeadCapture/ExhibitorPasscodes/ExhibitorPasscodes.module.css'

const PasscodeItem = ({ index, passcode }) => {    
    const changeDateTimeFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
        };
        return date.toLocaleDateString('en-us', options);
    }
    return (
        <>
            <tr className={styles.trPasscodes} key={index}>
                <td className={styles.tdPasscodes}> {passcode.organization}</td>
                <td className={styles.tdPasscodes}> {passcode.passcode}</td>
                <td className={styles.tdPasscodes}> {passcode.firstName} {passcode.lastName}</td>
                <td className={styles.tdPasscodes}> {passcode.email}</td>
                <td className={styles.tdPasscodes}> {changeDateTimeFormat(passcode.createdDate)}</td>
            </tr>
        </>
    );
}

export default PasscodeItem;